//icon component used to show svg icons

import React from 'react'
import OrionSprite from '../assets/svg/orion-svg-sprite.svg'

const Icon = props => <svg className={`svg-icon ${props.className ? props.className : ''}`} style={props.style}>
    <use xlinkHref={`${OrionSprite}#${props.icon}`}/>
</svg>;

export default Icon;